import { trace, type Tracer } from '@opentelemetry/api'
import { WebTracerProvider } from '@opentelemetry/sdk-trace-web'
import { BatchSpanProcessor } from '@opentelemetry/sdk-trace-base'
import { resourceFromAttributes } from '@opentelemetry/resources'
import { ATTR_SERVICE_NAME } from '@opentelemetry/semantic-conventions'
import { registerInstrumentations } from '@opentelemetry/instrumentation'
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request'
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch'
import { DocumentLoadInstrumentation } from '@opentelemetry/instrumentation-document-load'
import { AuthenticatedOtlpExporter } from './AuthenticatedOtlpExporter'

let provider: WebTracerProvider | null = null

const IGNORE_URLS = [/\/api\/ingest\//]

export function initTracing(): void {
  if (provider) return

  const resource = resourceFromAttributes({
    [ATTR_SERVICE_NAME]: 'Vigia-Front',
    'deployment.environment': import.meta.env.MODE,
  })

  const exporter = new AuthenticatedOtlpExporter()
  const spanProcessor = new BatchSpanProcessor(exporter, {
    scheduledDelayMillis: 2000,
    maxExportBatchSize: 64,
    maxQueueSize: 512,
  })

  provider = new WebTracerProvider({
    resource,
    spanProcessors: [spanProcessor],
  })

  provider.register()

  registerInstrumentations({
    instrumentations: [
      new XMLHttpRequestInstrumentation({
        ignoreUrls: IGNORE_URLS,
        propagateTraceHeaderCorsUrls: [/.*/],
      }),
      new FetchInstrumentation({
        ignoreUrls: IGNORE_URLS,
        propagateTraceHeaderCorsUrls: [/.*/],
      }),
      new DocumentLoadInstrumentation(),
    ],
  })
}

export function getTracer(name: string): Tracer {
  return trace.getTracer(name)
}

export async function shutdownTracing(): Promise<void> {
  if (provider) {
    await provider.shutdown()
    provider = null
  }
}
